import { useEffect, useRef } from "react";
import { useAppContext } from "../../context/app-context/AppContext";
import { HeapManager } from "../../helpers/heap-manager";

export const HeapAnalytics = () => {
  const { currentOrg, appConfig, user } = useAppContext();
  const wasHeapEnabledRef = useRef<boolean | null>(null);

  const heapEnabled =
    appConfig.analytics?.heap?.enabled === true &&
    process.env.NODE_ENV !== "test" &&
    !!appConfig.analytics?.heap?.id;

  const heapId = appConfig.analytics?.heap?.id;

  useEffect(() => {
    // Wait for org to be loaded before tracking heap state
    if (!currentOrg) {
      return;
    }

    // Heap cannot be truly unloaded once running, so reload when going enabled -> disabled
    if (wasHeapEnabledRef.current === true && !heapEnabled) {
      window.location.reload();
      return;
    }
    wasHeapEnabledRef.current = heapEnabled;

    if (!heapEnabled || !heapId) {
      return;
    }

    try {
      const heapManager = new HeapManager();
      heapManager.initializeHeap(heapId);
      if (user) {
        heapManager.setIdentity(user.id, user.email, currentOrg.id);
      }
    } catch (error) {
      console.warn("Failed to initialize Heap Analytics:", error);
    }
  }, [heapEnabled, heapId, currentOrg, user]);

  return null;
};
